export default __webpack_public_path__ + "static/media/bookmark-icon.43e09a96.svg";